import { UseCaseInteractor } from '../../../kernel/use-case'
import { DataForReAssignResourceById } from '../domain/entities'
import { ReAssignaDataRepository } from '../domain/re-assign-data.repository'

export const updateTaskByResourceUseCase: UseCaseInteractor<
  [ReAssignaDataRepository],
  [payload: DataForReAssignResourceById],
  string
> = (reAssignaDataRepository) => async (payload) => reAssignaDataRepository.reAssignResourceById(payload)
